package horcrux.frontend.common.extensions

import horcrux.common.api.dtos.TheGrokAppChatMessage
import horcrux.common.api.dtos.UserChatMessage
import horcrux.common.types.ChatPageMessages
import horcrux.frontend.common.views.chat.ChatMessageData
import horcrux.frontend.common.views.chat.TheGrokApp
import horcrux.frontend.common.views.chat.User

val ChatPageMessages.chatMessageDataList: List<ChatMessageData>
    get() = chatMessages.map { chatMessage ->
        val messageSenderData = when (chatMessage) {
            is TheGrokAppChatMessage -> TheGrokApp(
                contextDocumentChunkAndMetadataList = chatMessage.contextDocumentChunkAndMetadataList
            )

            is UserChatMessage -> User()
        }
        ChatMessageData(chatMessage.message.content, messageSenderData)
    }
